'use client';

import { useLogout } from '@/hooks/useLogout';
import { Button } from '@mui/material';
import { googleLogout } from '@react-oauth/google';
import { useState } from 'react';
import Loading from './Loading';
export default function LogoutButton() {
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const {
    mutate: logout,
    isPending
  } = useLogout();
  return <>
      <Button onClick={() => {
      logout();
      setIsLoggingOut(true);
      googleLogout();
    }} disabled={isPending} variant="outlined" color="inherit" data-sentry-element="Button" data-sentry-source-file="LogoutButton.tsx">
        {isPending ? 'Logging out…' : 'Log out'}
      </Button>
      {isLoggingOut ? <Loading message="Logging out..." /> : null}
    </>;
}